import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import YouTubePlayer from 'react-youtube';
import YoutubeProp from '../propTypes/youtubeProp';

export default function YoutubePlayer(props) {
  const { video, onVideoFinished, startPlaying } = props;
  const playerVars = startPlaying ? { autoplay: 1 } : {};

  const [showVideo, setShowVideo] = useState(false);
  useEffect(() => setShowVideo(true), []);

  const containerStyle = { width: '100%', height: '100%' };
  return (
    <>
      {showVideo ? (
        <YouTubePlayer
          videoId={video && video.id}
          style={containerStyle}
          opts={{
            height: '424',
            width: '666',
            playerVars: {
              ...playerVars,
              rel: 0,
            },
          }}
          onEnd={onVideoFinished}
        />
      ) : (
        <div style={containerStyle} />
      )}
    </>
  );
}

YoutubePlayer.propTypes = {
  video: PropTypes.shape(YoutubeProp.propType).isRequired,
  onVideoFinished: PropTypes.func,
  startPlaying: PropTypes.bool,
};

YoutubePlayer.defaultProps = {
  onVideoFinished: () => null,
  startPlaying: false,
};
